export const environment = {
  production: true,
  buildId: '2663892086818261',
  configFile: 'config.json',
};
